module.exports = __webpack_public_path__ + "c1c38d2913101f4aaa628437ea03fc2c.jpg";